import { Typography } from "@mui/material";
import React, { useEffect } from "react";
import MailOutlined from "../../../resources/icons/mail outlined.png";
import Telefon from "../../../resources/icons/telefon.png";
import logo from "../../../resources/images/logo2.png";

import("./Contact.css")

export const Contact = ({ onMount }) => {
    useEffect(() => {
        onMount("Kontakt")
    });

    return (
      <div className="contact-container">
        <img className="logo" alt="main logo" src={logo} />
        <Typography variant="h6" align="center">
          Bei Fragen, Anregungen und Kritik
        </Typography>
        <Typography variant="h6" align="center">
          -
        </Typography>
        <Typography variant="h5" align="center">
          Kontaktiere uns!
        </Typography>
        <div className="contact-method-wrapper">
          <img className="contact-method-icon" alt="Mail" src={MailOutlined} />
          <Typography variant="body1" align="center">
            robert@hizis.de
          </Typography>
        </div>
        <div className="contact-method-wrapper">
          <img className="contact-method-icon" alt="Phone" src={Telefon} />
          <Typography variant="body1" align="center">
            01577 8259952
          </Typography>
        </div>
      </div>
    );
}
